import React, { Fragment } from 'react'
import { Section } from './AutoFormStyled'
import IncResBtn from './IncResBtn'
import Input from 'components/input/Input'
import SFXS from '../../assets/audios/audios'
interface IncreaseByProps {
  title: string
  increase: boolean
  percent: string
  handleOnWin: any
  audio: any
  datatestid?: string
}

export default function IncreaseBy({
  title,
  increase,
  percent,
  handleOnWin,
  audio,
  datatestid,
}: IncreaseByProps) {
  const { switchSFX } = SFXS
  switchSFX.volume = audio.volume

  const handleSwitch = (inc: boolean, perc: string) => {
    handleOnWin(inc, perc)
    audio.sound && (switchSFX.load(), switchSFX.play())
  }

  return (
    <Fragment>
      <h6>{title}</h6>
      <Section border evenly data-testid={datatestid}>
        <IncResBtn
          active={!increase}
          func={() => increase && handleSwitch(false, percent)}
          text='Reset'
        />
        <IncResBtn
          active={increase}
          func={() => !increase && handleSwitch(true, percent)}
          text='Increase By'
        />
        <Input
          number={percent}
          setnumber={(e: string) => handleOnWin(e > '0' ? true : increase, e)}
          setinputStake={(e: string) =>
            handleOnWin(e > '0' ? true : increase, e)
          }
          type='onlyNumbers'
          min='0'
          max='1000'
          maxLength={3}
          width='42px'
          height='24px'
          size='16px'
          textcenter='right'
          toFix={0}
        />
        %
      </Section>
    </Fragment>
  )
}
